import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Footer, Header, Testimonials } from './container';
import WorkDetails from './container/WorkDetails/WorkDetails';
import { Navbar } from './components';
import SkillsDetails from './container/SkillsDetails/SkillsDetails';
import MyWorks from './container/MyWorks/MyWorks';

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
  {
    path:"/",
    element:<App/>,
    errorElement:<div >
      <div style={{justifyContent:'center', alignItems:'center', display:'flex' , height:"100vh", width:'100%'}}>
      <h1>404 Error</h1>
    </div>
    </div>

  },
  {
    path:"/workdetails",
    element:<WorkDetails/>
  },
  {
    path:"/skilldetails",
    element:<SkillsDetails />
  },

  {
    path:"/myworks",
    element: <MyWorks/>
  }
])
  
root.render(
  <React.StrictMode>
    <Navbar/>
    <RouterProvider router={router}/>
    
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
